export const CONFIG = {
  token: {
    pattern: /xxxxx\d{4,}/,
    patternGlobal: /xxxxx\d{4,}/g,
    patternExact: /^xxxxx\d{4,}$/,
  },
  pdf: {
    maxSize: 50 * 1024 * 1024, // 50MB
    magic: [0x25, 0x50, 0x44, 0x46, 0x2d], // %PDF-
    paragraphGap: 15,
    lineGap: 5,
    largeGap: 50,
    smallGap: 3,
  },
  ui: {
    copyTimeout: 2000,
    blurDelay: 150,
  },
}

export const INSTRUCTION_PRESETS = [
  {
    id: 'general',
    label: 'General',
    text: 'Review the following text. Some words have been replaced with tokens to protect sensitive information (e.g. xxxxx0001): ',
  },
  {
    id: 'legal',
    label: 'Legal / Contract',
    text: 'Review this document. Client names and confidential terms have been replaced with tokens for privacy (e.g. xxxxx0001): ',
  },
  {
    id: 'code',
    label: 'Code Review',
    text: 'Review this code. API keys, credentials, and proprietary names have been replaced with tokens (e.g. xxxxx0001): ',
  },
  {
    id: 'medical',
    label: 'Medical / Health',
    text: 'Review this health information. Patient names and identifiers have been replaced with tokens for privacy compliance (e.g. xxxxx0001): ',
  },
  {
    id: 'custom',
    label: 'Custom',
    text: '',
  },
]
